import { DateTime, TableColumn } from 'ui/components'
import { EmailHistoryReportItem } from '~bank-reports/types/EmailHistoryReport'

export const columns = (): TableColumn<EmailHistoryReportItem>[] => [
  {
    title: 'Sent At',
    align: 'left',
    render: ({ sentAt }) => <DateTime withTime date={sentAt} />
  },
  {
    title: 'Email address',
    key: 'email',
    align: 'left'
  },
  {
    title: 'Subject',
    key: 'subject',
    align: 'left'
  },
  {
    title: 'Status',
    align: 'left',
    render: ({ status }) => <>{status}</>
  },
  {
    title: 'Bounce message',
    key: 'bounceMessage',
    align: 'left'
  }
]
